<ng-container *ngIf="isDialogOpened">
  <kendo-window [title]="'templateSelection' | translate"
                [minWidth]="500"
                [width]="500"
                [minHeight]="290"
                (close)="cancel()"
                class="top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog kendo-window-with-titlebar">
    <div class="dialogContainer">
      <div class="dialogContainerLeft">
        <table aria-hidden="true">
          <tr>
            <td class="LabelContainer dialogField">
              <span class="dialogLabel uppercase">{{ 'reportDesignerDialog.templateLanguage' | translate }}</span>
            </td>
            <td style="width:20px;"></td>
          </tr>
          <tr>
            <td>
              <div class="FieldContainer">
                <kendo-dropdownlist style="width: 100%; border-bottom: 1px dashed #E30613; border-radius: inherit;"
                                    [data]="availableLanguagesDataSource"
                                    textField="description"
                                    valueField="id"
                                    [(ngModel)]="selectedLanguageId"
                                    (valueChange)="languageChanged()"
                                    [valuePrimitive]="true"></kendo-dropdownlist>
              </div>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel">{{ 'reportDesignerDialog.selectTemplate' | translate }}</span>
            </td>
            <td style="width:20px;"></td>
          </tr>
          <tr>
            <td>
              <div class="FieldContainer">
                <kendo-dropdownlist style="width: 100%; border-bottom: 1px dashed #E30613; border-radius: inherit;"
                                    [data]="availableTemplatesDataSource"
                                    [textField]="'Name'"
                                    [valueField]="'Oid'"
                                    [(ngModel)]="selectedTemplateOid"
                                    (valueChange)="templateChanged()"
                                    [valuePrimitive]="true"></kendo-dropdownlist>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="dialogContainerRight">
      </div>
    </div>
    <div class="dialogButtonBar">
      <div class="reportDesignerButtonBarBorder">
        <div class="ButtonBar">
          <button kendoButton class="ButtonWidth_110px" [disabled]="!enableLoad" (click)="loadTemplate()">{{ 'reportDesignerDialog.load' | translate }}</button>
          <button kendoButton class="ButtonWidth_110px" style="margin-left: 10px;" (click)="cancel()">{{ 'reportDesignerDialog.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
